"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIT_ID_ALL_USERS = exports.UNIT_ID_OWNERS = exports.Unit = void 0;
const tslib_1 = require("tslib");
const Entity_1 = require("../../../core/domain/Entity");
const Guard_1 = require("../../../core/logic/Guard");
const Unit_validator_1 = tslib_1.__importDefault(require("./Unit.validator"));
const messages_1 = require("../../constants/messages");
class Unit extends Entity_1.Entity {
    constructor(p, ref, id) {
        super(p, ref, id);
    }
    static validate(raw, ref, id) {
        try {
            Unit_validator_1.default(raw);
            return Guard_1.Guard.pass();
        }
        catch (e) {
            Entity_1.Entity.handleValidationError(e, ref, id);
            return Guard_1.Guard.fail(e.message);
        }
    }
    static create(p, ref, id) {
        const res = new Unit(p, ref, id);
        return res;
    }
    get usersArr() {
        return this.value.users ? Object.keys(this.value.users) : [];
    }
    get name() {
        return this.value.name || "";
    }
    get usersCnt() {
        return this.value.usersCnt;
    }
    get users() {
        return this.value.users;
    }
    get orgId() {
        return this.value.orgId;
    }
    get setting() {
        return this.value.setting;
    }
    get labels() {
        return this.value.labels;
    }
    get description() {
        return this.value.description || "";
    }
    get comment() {
        return this.value.comment || "";
    }
    static findAvailableId(currentIds) {
        for (const id of Unit.INDEXED_UNITS) {
            if (!currentIds.includes(id))
                return id;
        }
        throw new Error(messages_1.Errors.maxUnitsPerOrg);
    }
}
exports.Unit = Unit;
Unit.INDEXED_UNITS = [
    "OWN",
    "ALL",
    "U1",
    "U2",
    "U3",
    "U4",
    "U5",
    "U6",
    "U7",
    "U8",
    "U9",
    "U10",
    "U11",
    "U12",
    "U13",
    "U14",
    "U15",
    "U16",
    "U17",
    "U18",
    "U19",
    "U20",
];
exports.UNIT_ID_OWNERS = "OWN";
exports.UNIT_ID_ALL_USERS = "ALL";
//# sourceMappingURL=Unit.js.map